(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/react/row-banner.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/react/row-banner.js');

'use strict';

const {
  useRef,
  useEffect
} = React;
const rowBanner = svs.numbergames.andra_chansen_banners.rowBanner;

const AndraChansenRowBanner = _ref => {
  let {
    chances,
    isSubscription,
    shouldShowIcon,
    size,
    classNames
  } = _ref;
  const ref = useRef();
  useEffect(() => {
    const row = rowBanner({
      chances,
      isSubscription,
      shouldShowIcon,
      size,
      classNames
    });
    ref.current.appendChild(row.render());
    return function cleanup() {
      if (ref.current) {
        ref.current.innerHTML = '';
      }
    };
  }, [classNames, chances, isSubscription, size, shouldShowIcon]);
  return React.createElement("div", {
    ref: ref
  });
};
svs.numbergames.ReactAndraChansenBanners.AndraChansenRowBanner = AndraChansenRowBanner;

 })(window);